import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledLoginPage = styled.div`
    background-color: var(--color-primary);

    .main-login-section {
        position: relative;
        padding: 60px 50px 60px 50px;
        @media ${breakpoints.sm} {
            padding-left: 15px;
            padding-right: 15px;
        }
        @media ${breakpoints.xs} {
            padding-top: 35px;
        }

        .login-principal {
            position: relative;

            .mobile-container-helper {
                display: flex;
            }

            h1 {
                margin-top: 0;
                @media ${breakpoints.sm} {
                    font-size: var(--size-20);
                }
                @media ${breakpoints.xs} {
                    width: 85%;
                    margin-top: 0;
                    margin-right: 15px;
                    font-size: var(--size-18);
                }
            }

            .login-secondary-text {
                width: 85%;
                font-size: var(--size-18);
                line-height: 25px;
                color: var(--color-primary-fg);
                @media ${breakpoints.sm} {
                    width: 85%;
                    font-size: var(--size-16);
                }
                @media ${breakpoints.xs} {
                    width: 100%;
                    font-size: var(--size-14);
                }
            }
        }

        .login-container {
            max-width: 390px;
            margin: 40px auto 0;
            @media ${breakpoints.xs} {
                max-width: 100%;
                margin-top: 5px;
            }

            form {
                h2 {
                    font-weight: 800;
                    color: var(--color-primary-fg);
                }

                .forgot-password-label {
                    margin-bottom: 3rem;
                    font-size: var(--size-16);
                    font-weight: bold;
                    color: var(--color-primary-fg);
                    text-decoration: underline;
                    cursor: pointer;
                    @media ${breakpoints.sm} {
                        margin-bottom: 2.1rem;
                    }
                }

                label {
                    .MuiCheckbox-root {
                        color: var(--color-primary-fg);

                        svg {
                            font-size: var(--size-20);
                        }
                    }

                    .remember-me {
                        font-size: var(--size-16);
                        color: var(--color-primary-fg);
                        @media ${breakpoints.sm} {
                            font-size: var(--size-14);
                        }
                    }
                }
            }
        }
    }

    .login-secondary-section {
        padding: 10px 50px 0 50px;
        background-color: var(--color-grey-400);
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        @media ${breakpoints.sm} {
            padding: 10px 15px 20px 15px;
        }
    }
`;
